
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as echarts from 'echarts'
@Component({
  name: 'TurnoverStatistics',
})
export default class extends Vue {
  @Prop() private turnoverdata!: any
  @Watch('turnoverdata')
  getData() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  initChart() {
    type EChartsOption = echarts.EChartsOption
    const chartDom = document.getElementById('main') as any
    const myChart = echarts.init(chartDom)

    const toNumbers = (arr: any): number[] => {
      if (!Array.isArray(arr)) return []
      return arr
        .map((v) => (typeof v === 'string' ? Number(v) : v))
        .filter((v) => typeof v === 'number' && isFinite(v))
    }

    const niceCeil = (v: number): number => {
      if (!isFinite(v) || v <= 0) return 0
      const exp = Math.pow(10, Math.floor(Math.log10(v)))
      const f = v / exp
      const nf = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10
      return nf * exp
    }

    const calcAxis = (values: number[]) => {
      if (!values.length) {
        return { min: 0, max: 5, interval: 1 }
      }
      const max0 = Math.max(...values)
      const paddedMax = max0 <= 0 ? 1 : max0 * 1.1
      const interval = Math.max(1, niceCeil(paddedMax / 5))
      const max = interval * 5
      return { min: 0, max, interval }
    }

    const axis = calcAxis([
      ...toNumbers(this.turnoverdata && this.turnoverdata.turnoverList),
      ...toNumbers(this.turnoverdata && this.turnoverdata.nonWalletTurnoverList),
    ])

    var option: any
    option = {
      // title: {
      //   text: '营业额(元)',
      //   top: 'bottom',
      //   left: 'center',
      //   textAlign: 'center',
      //   textStyle: {
      //     fontSize: 12,
      //     fontWeight: 'normal',
      //   },
      // },
      tooltip: {
        trigger: 'axis',
      },
      // 图例用下方 HTML（与订单统计一致），避免与 chart legend 叠字
      grid: {
        top: '5%',
        left: '10',
        right: '50',
        bottom: '12%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          //X轴字体颜色
          textStyle: {
            color: '#666',
            fontSize: '12px',
          },
        },
        axisLine: {
          //X轴线颜色
          lineStyle: {
            color: '#E5E4E4',
            width: 1, //x轴线的宽度
          },
        },
        data: this.turnoverdata.dateList, //后端传来的动态数据
      },
      yAxis: [
        {
          type: 'value',
          min: axis.min,
          max: axis.max,
          interval: axis.interval,
          axisLabel: {
            textStyle: {
              color: '#666',
              fontSize: '12px',
            }
            // formatter: "{value} ml",//单位
          }
        }
      ],
      series: [
        {
          name: '营业额',
          type: 'line',
          // stack: 'Total',
          smooth: false, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10,
          // symbol:"circle", //设置折线点定位实心点
          itemStyle: {
            normal: {
              color: '#4DA3FF',
              lineStyle: {
                color: '#4DA3FF',
              },
            },
            emphasis: {
              color: '#fff',
              borderWidth: 5,
              borderColor: '#4DA3FF',
            },
          },

          data: this.turnoverdata.turnoverList,
        },
        {
          name: '不含余额',
          type: 'line',
          smooth: false,
          showSymbol: false,
          symbolSize: 10,
          itemStyle: {
            normal: {
              color: '#FD7F7F',
              lineStyle: {
                color: '#FD7F7F',
              },
            },
            emphasis: {
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FD7F7F',
            },
          },
          data: this.turnoverdata.nonWalletTurnoverList || [],
        },
      ],
    }
    option && myChart.setOption(option)
  }
}
